import { useCreateGSTPayout } from "@entities/campaigns/lib/hooks/useCreateGSTPayout";
import { ToastService } from "@shared/lib/services";
import { IInvoice } from "@shared/lib/types/briefCampains";
import { Button } from "@shared/ui/Button";
import { Descriptions, Flex, Input, InputNumber, Select, Space } from "antd";
import { useEffect, useState } from "react";

export function GstPayout({
  campaignInfluencerId,
  maxAmount,
  onClose,
  primaryContactText,
  isPrimaryEmail,
  invoices,
}: {
  campaignInfluencerId: string;
  maxAmount: number;
  onClose: () => void;
  primaryContactText: string;
  isPrimaryEmail: boolean;
  invoices: IInvoice[];
}) {
  const [partialAmount, setpartialAmount] = useState<number>(0);
  const [remarks, setRemarks] = useState<string>("");
  const [linkedInvoiceId, setLinkedInvoiceId] = useState<string>("");
  const { createGSTPayout, isCreating, isCreated } =
    useCreateGSTPayout(campaignInfluencerId);

  const handleSubmit = () => {
    createGSTPayout({
      campaignInfluencerId,
      linkedInvoiceId,
      amount: partialAmount,
      remarks,
    });
  };
  useEffect(() => {
    if (isCreated) {
      ToastService.success("GST Payout created successfully");
      onClose();
    }
  }, [isCreated]);
  return (
    <Flex vertical gap={32}>
      <Space>
        <Input
          placeholder="Remarks"
          value={remarks}
          onChange={(e) => setRemarks(e.target.value)}
        />
        <InputNumber
          addonBefore={"Amount ₹"}
          style={{ width: "200px" }}
          value={partialAmount}
          onChange={(value) => {
            setpartialAmount(value || 0);
          }}
          max={maxAmount}
          min={0}
        />
      </Space>

      <Select
        prefix={<h4> Linked Invoice: </h4>}
        style={{ width: "100%" }}
        placeholder="Select Linked Invoice"
        options={invoices.map((invoice) => ({
          label: invoice.remarks,
          value: invoice._id,
        }))}
        value={linkedInvoiceId}
        onChange={(value) => setLinkedInvoiceId(value)}
      />

      <div>
        <p>
          Are you sure you want to pay the influencer/agency the full amount of
          ₹ (<strong>{partialAmount.toFixed(2)}</strong>)
        </p>
        <p>
          The payout link will be sent to the following{" "}
          <strong>
            {isPrimaryEmail
              ? `Email: ${primaryContactText}`
              : `Phone Number: ${primaryContactText}`}
          </strong>
        </p>
      </div>
      <Flex justify="end" gap={8}>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          type="primary"
          onClick={handleSubmit}
          loading={isCreating}
          disabled={!linkedInvoiceId}
        >
          Confirm
        </Button>
      </Flex>
    </Flex>
  );
}
